import {ROUTE_REGEX_BASE64_URL} from '@/utils/portuna';
import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';

const CustomerStatisticIndex              = () => import('../../views/customer/statistic/CustomerStatisticIndex.vue');
const CustomerStatisticHosting            = () => import('../../views/customer/statistic/CustomerStatisticHosting.vue');
const CustomerStatisticTerminatedAfter    = () => import('../../views/customer/statistic/CustomerStatisticTerminatedAfter.vue');
const CustomerStatisticTerminationAverage = () => import('../../views/customer/statistic/CustomerStatisticTerminationAverage.vue');
const CustomerStatisticPortfolio          = () => import('../../views/customer/statistic/CustomerStatisticPortfolio.vue');

const meta: MetaData = {
    module: 'customer',
};

let routes: RouteRecordRaw[] = [
    {
        path: '/customer/statistic',
        redirect: {name: 'customer-statistic-index'},
    },
    {
        name: 'customer-statistic-index',
        path: '/customer/statistic/list/:view(monthly|yearly)?/:categories(' + ROUTE_REGEX_BASE64_URL + ')?',
        meta,
        component: CustomerStatisticIndex,
        props(route: RouteLocationStringParam)
        {
            return {
                view: route.params.view,
                categories: route.params.categories ? JSON.parse(atob(route.params.categories)) : [],
            };
        },
    },
    {
        name: 'customer-statistic-hosting',
        path: '/customer/statistic/hosting/:view?',
        meta,
        component: CustomerStatisticHosting,
        props(route: RouteLocationStringParam)
        {
            return {
                view: ['monthly', 'yearly', 'seller'].includes(route.params.view) ? route.params.view : 'monthly',
            };
        },
    },
    {
        name: 'customer-statistic-terminated-after',
        path: '/customer/statistic/terminated-after',
        meta,
        component: CustomerStatisticTerminatedAfter,
    },
    {
        name: 'customer-statistic-termination-average',
        path: '/customer/statistic/termination-average',
        meta,
        component: CustomerStatisticTerminationAverage,
    },
    {
        name: 'customer-statistic-portfolio',
        path: '/customer/statistic/portfolio',
        meta,
        component: CustomerStatisticPortfolio,
    },
];

export default routes;
